import { CheckSquare, Phone, Users, Mail, MapPin, CalendarHeart, CircleDot } from "lucide-react";

export const TYPE_ICON = {
  Task: CheckSquare, Call: Phone, Meeting: Users, Email: Mail, "Site Visit": MapPin, Event: CalendarHeart, Other: CircleDot,
};

export function TypeIcon({ type, className = "h-3.5 w-3.5" }) {
  const Icon = TYPE_ICON[type] || CircleDot;
  return <Icon className={className} aria-label={type} />;
}

const TYPE_COLOR = {
  Task: "bg-sky-50 text-sky-600", Call: "bg-emerald-50 text-emerald-600", Meeting: "bg-indigo-50 text-indigo-600",
  Email: "bg-amber-50 text-amber-600", "Site Visit": "bg-rose-50 text-rose-600", Event: "bg-fuchsia-50 text-fuchsia-600",
  Other: "bg-slate-100 text-slate-500",
};
export const typeColor = (type) => TYPE_COLOR[type] || TYPE_COLOR.Other;
